import {User} from '@eitje/api'
import {useFilterCache} from '../hooks'
import _ from 'lodash'

export const getUserRecordsAndIds = ({taxonomies, name, orgCacheKey}) => {
	const listPickerOptions = taxonomies.find(t => t.filterName === 'user')?.items
	const cacheValue = useFilterCache({filterName: 'user', name, orgCacheKey})
	const usersCache = User.useWhere(cacheValue)

	const pickerUsers = listPickerOptions
	const pickerIds = listPickerOptions?._map('id').uniq().sort()

	// If no IDs are stored in Redux, that effectively means that all options are selected.
	const useCache = !_.isEmpty(cacheValue)
	const useOptions = !_.isEmpty(listPickerOptions)
	let users
	let userIds

	if (useCache) {
		users = usersCache
		userIds = cacheValue
	} else if (useOptions) {
		users = pickerUsers
		userIds = pickerIds
	} else {
		users = []
		userIds = []
	}

	return {
		users,
		userIds,
	}
}
